import { Fragment } from 'react';

import { Field, FieldLabel } from '@playbooks/ui/components/field';
import { Input } from '@playbooks/ui/components/input';
import { Textarea } from '@playbooks/ui/components/textarea';

const CollectionAbbreviatedFields = ({ collection, setCollection }) => {
	// Render
	return (
		<Fragment>
			<Field>
				<FieldLabel>Name</FieldLabel>
				<Input value={collection.name || ''} onChange={e => setCollection({ ...collection, name: e.target.value })} />
			</Field>

			<Field>
				<FieldLabel>Description</FieldLabel>
				<Textarea
					value={collection.description || ''}
					placeholder=''
					onChange={e => setCollection({ ...collection, description: e.target.value })}
				/>
			</Field>
		</Fragment>
	);
};
export { CollectionAbbreviatedFields };
